import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import MailComposer from './MailComposer';

const MailComposerContext = createContext({ openComposer: () => {} });

/**
 * The e-mail window of the app, as Gmail's: it floats at the bottom right
 * over any page and stays when the page changes. `openComposer(data)` opens
 * it for a record ({ companyId | groupId, recordName, contacts, contactName }),
 * in place of the one open.
 */
const MailComposerProvider = ({ children }) => {
  // `opening` tells two openings apart, so that the window starts afresh.
  const [draft, setDraft] = useState(null);
  const openComposer = useCallback((data) => setDraft({ ...data, opening: Date.now() }), []);
  const close = useCallback(() => setDraft(null), []);
  const value = useMemo(() => ({ openComposer }), [openComposer]);
  return (
    <MailComposerContext.Provider value={value}>
      {children}
      {draft && <MailComposer key={draft.opening} data={draft} onClose={close} />}
    </MailComposerContext.Provider>
  );
};

export const useMailComposer = () => useContext(MailComposerContext);

export default MailComposerProvider;
